import React, { useCallback, useEffect, useState } from 'react'
import { Loader, Dimmer } from 'semantic-ui-react'
import { useTheme } from 'contexts/ThemeProvider'

const Loading = ({ inverted = true, centerInView = false, contentAreaRef }) => {
  const { isDark } = useTheme()
  const [loaderPosition, setLoaderPosition] = useState({ top: '50%' })
  const [isPositioned, setIsPositioned] = useState(!centerInView)

  const updateLoaderPosition = useCallback(() => {
    const listElement =
      document.querySelector('.my-health-content-area') ??
      contentAreaRef?.current
    if (listElement) {
      const rect = listElement.getBoundingClientRect()
      const scrollY = window.scrollY || window.pageYOffset
      const viewportHeight = window.innerHeight

      const listTop = rect.top + scrollY
      const listBottom = listTop + rect.height
      const viewportTop = scrollY
      const viewportBottom = scrollY + viewportHeight

      const visibleTop = Math.max(listTop, viewportTop)
      const visibleBottom = Math.min(listBottom, viewportBottom)

      const visibleCenter = visibleTop + (visibleBottom - visibleTop) / 2

      const top = visibleCenter - listTop

      setLoaderPosition({ top: `${top}px` })
      setIsPositioned(true)
    }
  }, [contentAreaRef])

  useEffect(() => {
    if (centerInView) {
      updateLoaderPosition()
      window.addEventListener('resize', updateLoaderPosition)
      window.addEventListener('scroll', updateLoaderPosition)
      window.addEventListener('orientationchange', updateLoaderPosition)
      return () => {
        window.removeEventListener('resize', updateLoaderPosition)
        window.removeEventListener('scroll', updateLoaderPosition)
        window.removeEventListener('orientationchange', updateLoaderPosition)
      }
    }
  }, [centerInView, updateLoaderPosition])

  const dimmerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }

  const loaderStyle = centerInView
    ? {
        position: 'absolute',
        top: loaderPosition.top,
        left: '50%',
        transform: 'translate(-50%, -50%)',
        visibility: isPositioned ? 'visible' : 'hidden'
      }
    : {}

  return (
    <Dimmer active inverted={inverted && !isDark} style={dimmerStyle}>
      <Loader style={loaderStyle} />
    </Dimmer>
  )
}

export default Loading
